import { NumericFormat } from "react-number-format";
import { Input, Text } from "../../../editForms/salaries/CustomInputs";

type Props = {
  name: string;
  value: number;
  type: "text" | "input";
};

export const SalaryNumericFormat = ({ name, value, type }: Props) => (
  <NumericFormat
    name={name}
    value={value}
    decimalSeparator=","
    valueIsNumericString
    customInput={type === "text" ? Text : Input}
    decimalScale={2}
    textAlign="start"
    maxWidth="120px"
    disabled={type === "input"}
  />
);
